/**
 * One list of destinations for every navigation surface.
 * Six pillars, in the order the research reads: players, facilities, land, numbers, returns, sources.
 */
export const NAV_GROUPS = [
  {
    heading: "Players",
    icon: "trophy",
    primary: 5,
    links: [
      ["Hall of Fame Top 20", "/hall-of-fame/leaderboard"],
      ["All Players", "/hall-of-fame"],
      ["Player Valuations", "/valuations"],
      ["First To Do It", "/firsts"],
      ["The Women's Game", "/womens-game"],
      ["Historic Players", "/hall-of-fame?list=historic"],
      ["Ones To Watch", "/hall-of-fame?list=ones_to_watch"],
    ],
  },
  {
    heading: "Facilities",
    icon: "ruler",
    primary: 5,
    links: [
      ["Facility Library", "/facilities"],
      ["Facility Planner", "/facility-planner"],
      ["Compare Two Facilities", "/compare-facilities"],
      ["Pitch Sizing and Land", "/pitch-sizing"],
      ["Modular Stadiums", "/modular-stadiums"],
      ["Futsal Court Rollout", "/court-rollout"],
    ],
  },
  {
    heading: "Counties and Land",
    icon: "map",
    primary: 5,
    links: [
      ["County Map", "/counties"],
      ["The National Rollup", "/counties/rollup"],
      ["Compare Two Counties", "/compare"],
      ["One-Page Comparison Sheet", "/counties/compare-sheet"],
      ["County Land Values", "/land-value/nairobi"],
      ["What Your Idle Acre Is Worth", "/idle-acre"],
      ["Site Development Scenario", "/site-appraisal"],
      ["Lease Comparison", "/lease-comparison"],
      ["County Land Audit", "/land-audit"],
    ],
  },
  {
    heading: "The Numbers",
    icon: "coins",
    primary: 5,
    links: [
      ["Capex, Opex and Returns", "/money"],
      ["The National Rollup", "/counties/rollup"],
      ["The Value Case", "/value-case"],
      ["Football As An Economy", "/football-economy"],
      ["Player Trading Model", "/trading"],
      ["County Funding Scenarios", "/county-scenarios"],
      ["The Recommended Steps", "/plans"],
      ["The Governors' League", "/governors-league"],
    ],
  },
  {
    heading: "Returns and Impact",
    icon: "heart",
    primary: 5,
    links: [
      ["Football Projects and Activities", "/grassroots"],
      ["Health and Fitness", "/health-and-fitness"],
      ["Training and Jobs", "/training-and-jobs"],
      ["Orphans in Football", "/impact/orphans-in-football"],
      ["Women in Football", "/impact/women-in-football"],
      ["Refugees in Football", "/refugees-in-football"],
      ["Disabilities in Football", "/disabilities-in-football"],
    ],
  },
  {
    heading: "Research",
    icon: "compass",
    primary: 5,
    links: [
      ["Sources and Method", "/sources"],
      ["Licence and Source Register", "/licences"],
      ["Sport and the Law", "/sports-law"],
      ["Licensed Professionals", "/professionals"],
      ["News and Stories", "/news"],
      ["Development Updates", "/updates"],
      ["The National Game", "/national-game"],
      ["About Us", "/about"],
      ["Contact", "/contact"],
    ],
  },
];

/** Six tabs on the phone, one per pillar. */
export const MOBILE_TABS = [
  { label: "Players", short: "Players", icon: "trophy", groups: ["Players"] },
  { label: "Facilities", short: "Build", icon: "ruler", groups: ["Facilities"] },
  { label: "Counties and Land", short: "Land", icon: "map", groups: ["Counties and Land"] },
  { label: "The Numbers", short: "Money", icon: "coins", groups: ["The Numbers"] },
  { label: "Returns and Impact", short: "Impact", icon: "heart", groups: ["Returns and Impact"] },
  { label: "Research", short: "Research", icon: "compass", groups: ["Research"] },
];

/** The footer is short on purpose. */
export const FOOTER_COLS = [
  {
    title: "The Research",
    links: [
      ["Player Valuations", "/valuations"],
      ["Facility Library", "/facilities"],
      ["County Map", "/counties"],
      ["Capex, Opex and Returns", "/money"],
      ["Sources and Method", "/sources"],
    ],
  },
  {
    title: "Take Part",
    links: [
      ["Send Us Your Research", "/apply"],
      ["Add, Correct Or Join In", "/contribute"],
      ["Ask To Be Listed", "/professionals/join"],
      ["News and Stories", "/news"],
      ["Development Updates", "/updates"],
      ["Training and Jobs", "/training-and-jobs"],
    ],
  },
  {
    title: "The Organisation",
    links: [
      ["About Us", "/about"],
      ["How We Work", "/how-we-work"],
      ["Contact", "/contact"],
      ["Privacy", "/privacy"],
      ["Terms", "/terms"],
    ],
  },
];

export const groupByHeading = (heading) => NAV_GROUPS.find((g) => g.heading === heading);
